<template>
  <div class="menu-overlay" id="menuOverlay"></div>
  <header class="main-navigation global-nav">
    <div class="side-mavi-logo">
      <picture>
        <source media="(max-width: 767px)" srcset="../../assets/images/logo/Menu_Phone.png" />
        <source media="(min-width: 768px)" srcset="../../assets/images/logo/Menu_PC.png" />
        <img src="../../assets/images/logo/Menu_PC.png" alt="skyviz" class="logo" />
      </picture>
      <!-- close -->
      <div class="closeMenuBtn" id="closeMenuBtn">
        <img src="../../assets/images/icon/button_close.svg" alt="閉じる" />
      </div>
    </div>

    <nav>
      <div class="main-navi-links">
        <p>気象情報</p>
        <ul>
          <li>
            <a
              href="/weather-over-view"
              class="header_navi_overview"
              :class="{ active: isActive('/weather-over-view'), 'is-disabled': isMenuDisabled }"
              @touchend.prevent.stop="(e) => handleTouchNavigate('/weather-over-view', e)"
              @click.prevent="(e) => handleClickNavigate('/weather-over-view', e)"
            >
              気象情報概況
            </a>
          </li>
          <li>
            <a
              href="/map-and-weather"
              class="header_navi_map"
              :class="{ active: isActive('/map-and-weather'), 'is-disabled': isMenuDisabled }"
              @touchend.prevent.stop="(e) => handleTouchNavigate('/map-and-weather', e)"
              @click.prevent="(e) => handleClickNavigate('/map-and-weather', e)"
            >
              地図＋気象
            </a>
          </li>
          <li>
            <a
              href="/observation-data-display"
              class="header_navi_data"
              :class="{
                active: isActive('/observation-data-display'),
                'is-disabled': isMenuDisabled,
              }"
              @touchend.prevent.stop="(e) => handleTouchNavigate('/observation-data-display', e)"
              @click.prevent="(e) => handleClickNavigate('/observation-data-display', e)"
            >
              観測データ表示
            </a>
          </li>
          <li>
            <a
              href="/settings"
              class="header_navi_config"
              :class="{ active: isSettingsActive(), 'is-disabled': isMenuDisabled }"
              @touchend.prevent.stop="(e) => handleTouchNavigate('/settings', e)"
              @click.prevent="(e) => handleClickNavigate('/settings', e)"
            >
              設定
            </a>
          </li>
        </ul>
      </div>
      <div class="sub-navi-links">
        <button class="button-tertiary" @click="openManual">
          <span></span> 操作マニュアル（PDF）
        </button>
        <button class="button-logout" @click="(e) => logoutUser(e)">ログアウト</button>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useFlightAreaStore } from '@/stores/flightArea'
import { computed, onMounted } from 'vue'
import { forceCloseGlobalNavMenu } from '@/composables/openMainMenu'

const flightAreaStore = useFlightAreaStore()
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
let lastTouchNavigateAt = 0

//飛行エリア未設定時はメニューを非活性にする
const isMenuDisabled = computed(() => flightAreaStore.flightAreas.length === 0)
const go = (path: string, e?: Event) => {
  if (isMenuDisabled.value) return

  if (e?.currentTarget instanceof HTMLElement) {
    e.currentTarget.blur()
  }

  // 先に閉じる
  if (window.innerWidth <= 767) {
    forceCloseGlobalNavMenu()
  }

  // その後遷移
  router.push(path)
}

// iPhone Safari でメニューボタンをタップした場合、下の画面のボタンにフォーカスが当たってしまうため
// touchend 後に発生する click は無視
const handleTouchNavigate = (path: string, e?: Event) => {
  lastTouchNavigateAt = Date.now()
  go(path, e)
}
const handleClickNavigate = (path: string, e?: Event) => {
  if (Date.now() - lastTouchNavigateAt < 700) {
    return
  }

  go(path, e)
}

const isActive = (path: string) => {
  return route.path === path
}

const isSettingsActive = () => {
  return (
    route.path === '/settings' ||
    route.path === '/drone-info' ||
    route.path === '/flight-areas' ||
    route.path === '/flight-routes' ||
    route.path.startsWith('/flight-routes-setting') ||
    route.path.startsWith('/flight-route-points')
  )
}

//操作マニュアルを開く
const openManual = () => {
  window.open('/operation-manual.pdf', '_blank')
}

//ログアウトする
const logoutUser = async (e?: Event) => {
  if (e?.currentTarget instanceof HTMLElement) {
    e.currentTarget.blur()
  }

  await userStore.logout()
  await router.push('/')
}

onMounted(async () => {
  await flightAreaStore.fetchFlightAreas()
})
</script>
